"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FooterColumn = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Row = _interopRequireDefault(require("../../foundational/Layout/Row"));
var _Col = _interopRequireDefault(require("../../foundational/Layout/Col"));
var _Container = _interopRequireDefault(require("../../foundational/Layout/Container"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _icons = require("../../assets/icons");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["column1", "column2", "column3", "className", "copyright", "footerButton", "socialIcons", "utilityLinks", "utilityButton"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Footer {\n  padding: 3rem 0;\n  background-color: #000000;\n}\n@media (max-width: 48rem) {\n  .Footer {\n    padding: 2rem 0;\n  }\n}\n@media (max-width: 48rem) {\n  .Footer__navigation nav {\n    margin-bottom: 3rem;\n  }\n}\n.Footer__navigation__column__title {\n  color: #ffffff;\n  font-size: 1.125rem;\n  line-height: 1.5rem;\n}\n.Footer__navigation__column__link {\n  margin: 1.5rem 0;\n  list-style: none;\n}\n.Footer__navigation__column__link a {\n  font-size: 0.875rem;\n  color: #ffffff;\n  opacity: 0.7;\n  transition: 0.15s ease-in-out;\n  text-decoration: none;\n}\n.Footer__navigation__column__link a:hover {\n  opacity: 1;\n  text-decoration: none;\n  color: #ffffff;\n}\n.Footer__navigation__container {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n}\n@media (max-width: 48rem) {\n  .Footer__navigation__container {\n    display: block;\n  }\n}\n.Footer__navigation__button {\n  border-radius: 0.25rem;\n  padding: 0.6rem 1rem 0.6rem 0.5rem;\n  display: flex;\n  align-items: center;\n  max-width: fit-content;\n  text-decoration: none;\n  margin-bottom: 3rem;\n  font-size: 0.875rem;\n  font-weight: bold;\n  color: #ffffff;\n  border: solid 1px #ffffff;\n  transition: ease-in-out 0.15s;\n  gap: 10px;\n  cursor: pointer;\n}\n@media (max-width: 48rem) {\n  .Footer__navigation__button {\n    margin-right: auto;\n    margin-left: unset;\n  }\n}\n@media (max-width: 25.875rem) {\n  .Footer__navigation__button {\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n.Footer__navigation__button .Icon {\n  height: 1.7rem !important;\n  min-width: 1.6rem !important;\n}\n.Footer__navigation__button:hover {\n  opacity: 1;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n.Footer__navigation__social_icons {\n  display: flex;\n  padding: 0 1rem;\n}\n@media (max-width: 48rem) {\n  .Footer__navigation__social_icons {\n    justify-content: start;\n  }\n}\n.Footer__navigation__social_icons__icon {\n  width: 2rem;\n  opacity: 0.7;\n  transition: ease-in-out 0.15s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.Footer__navigation__social_icons__icon:hover {\n  opacity: 1;\n}\n.Footer__hr {\n  margin-top: 3rem;\n  margin-bottom: 1.5rem;\n  border-style: solid;\n  border-color: #767676;\n  border-width: 0.5px;\n}\n.Footer__utility_nav__links {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.Footer__utility_nav__links__link a {\n  color: #ffffff;\n  opacity: 0.7;\n  transition: ease-in-out 0.15s;\n  text-decoration: none;\n  font-size: 0.875rem;\n  display: inline-flex;\n  align-items: center;\n  line-height: 2rem;\n}\n.Footer__utility_nav__links__link a:hover {\n  opacity: 1;\n  text-decoration: none;\n  color: #ffffff;\n}\n.Footer__utility_nav__links__link a svg {\n  height: 0.875rem;\n  margin-right: 0.25rem;\n}\n.Footer__utility_nav__links__link::after {\n  content: \" |\";\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.Footer__utility_nav__links__link:last-child::after {\n  content: \"\";\n  margin-left: 0;\n}\n.Footer__utility_nav__copyright {\n  color: #767676;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.Footer__utility_nav__copyright svg {\n  width: 1rem;\n  margin-left: 0.5rem;\n}";
  var fileName = "Footer_Footer";
  var element = document.querySelector("style[data-sass-component='Footer_Footer']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Footer = function Footer(_ref) {
  var _footerButton$icon, _footerButton$icon2, _footerButton$icon3, _utilityButton$icon, _utilityButton$icon2, _utilityButton$icon3;
  var column1 = _ref.column1,
    column2 = _ref.column2,
    column3 = _ref.column3,
    className = _ref.className,
    copyright = _ref.copyright,
    footerButton = _ref.footerButton,
    socialIcons = _ref.socialIcons,
    utilityLinks = _ref.utilityLinks,
    utilityButton = _ref.utilityButton,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", _objectSpread(_objectSpread({
    className: "Footer ".concat(className || '')
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Container["default"], {
      children: [(column1 || column2 || column3 || footerButton || socialIcons) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], {
          className: "Footer__navigation",
          children: [column1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(FooterColumn, {
            title: column1.title,
            links: column1.links
          }), column2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(FooterColumn, {
            title: column2.title,
            links: column2.links
          }), column3 && /*#__PURE__*/(0, _jsxRuntime.jsx)(FooterColumn, {
            title: column3.title,
            links: column3.links
          }), (footerButton && !utilityButton || socialIcons && socialIcons.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Col["default"], {
            className: "Footer__navigation__container",
            md: 6,
            xs: 3,
            children: [(footerButton == null ? void 0 : footerButton.link) && (footerButton == null ? void 0 : footerButton.label) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
              role: "label",
              className: "Footer__navigation__button",
              href: footerButton == null ? void 0 : footerButton.link,
              children: [(footerButton == null ? void 0 : (_footerButton$icon = footerButton.icon) == null ? void 0 : _footerButton$icon.src) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
                src: footerButton == null ? void 0 : (_footerButton$icon2 = footerButton.icon) == null ? void 0 : _footerButton$icon2.src,
                alt: footerButton == null ? void 0 : (_footerButton$icon3 = footerButton.icon) == null ? void 0 : _footerButton$icon3.alt,
                size: "utility"
              }), ' ', footerButton == null ? void 0 : footerButton.label]
            }), socialIcons && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "Footer__navigation__social_icons",
              children: socialIcons == null ? void 0 : socialIcons.map(function (icon, index) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                  className: "Footer__navigation__social_icons__icon",
                  href: icon.link,
                  target: "_blank",
                  rel: "noreferrer",
                  onClick: icon && icon.onClick,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
                    src: icon.src,
                    alt: icon.alt,
                    size: "utility"
                  })
                }, index);
              })
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
          className: "Footer__hr"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
        className: "Footer__utility_nav",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], {
          children: [utilityLinks && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Col["default"], {
            md: {
              order: 1
            },
            xs: {
              order: 2
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
              className: "Footer__utility_nav__links",
              children: utilityLinks.map(function (util, index) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                  className: "Footer__utility_nav__links__link",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
                    href: util.link,
                    children: [util && util.icon === 'pdf' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconPDF, {}), ' ', util.label]
                  })
                }, index);
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
              className: "Footer__utility_nav__copyright",
              children: [copyright || '', " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconLock, {}), " This is a secure site."]
            })]
          }), (utilityButton == null ? void 0 : utilityButton.link) && (utilityButton == null ? void 0 : utilityButton.label) && !footerButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
            md: !utilityLinks ? 12 : {
              order: 2,
              span: 4
            },
            xs: {
              order: 1,
              span: 6
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
              role: "label",
              className: "Footer__navigation__button",
              href: utilityButton == null ? void 0 : utilityButton.link,
              children: [(utilityButton == null ? void 0 : (_utilityButton$icon = utilityButton.icon) == null ? void 0 : _utilityButton$icon.src) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
                src: utilityButton == null ? void 0 : (_utilityButton$icon2 = utilityButton.icon) == null ? void 0 : _utilityButton$icon2.src,
                alt: utilityButton == null ? void 0 : (_utilityButton$icon3 = utilityButton.icon) == null ? void 0 : _utilityButton$icon3.alt,
                size: "utility"
              }), utilityButton == null ? void 0 : utilityButton.label]
            })
          })]
        }), !utilityLinks && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          className: "Footer__utility_nav__copyright",
          children: [copyright && copyright, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.IconLock, {}), " This is a secure site."]
        })]
      })]
    })
  }));
};
var FooterColumn = function FooterColumn(_ref2) {
  var title = _ref2.title,
    links = _ref2.links;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Col["default"], {
    md: 2,
    xs: 3,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      tabIndex: 0,
      id: title,
      className: "Footer__navigation__column__title",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
      children: links && links.map(function (link, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: "Footer__navigation__column__link",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: link.path,
            children: link.label
          })
        }, index);
      })
    })]
  });
};
exports.FooterColumn = FooterColumn;
var _default = Footer;
exports["default"] = _default;